import React from 'react'
import { firstValid } from '../page/utils'


const validPChildren = ['strong', 'em', 'code', 'b', 'a', 'span', 'fa', 'icon', 'cache', 'br', 'align', 'size', 'button', 'img', 'classes', 'clases']


const validAlign = {
	start: 'left',
	mid: 'center',
	middle: 'center',
	end: 'right',
	left: 'left',
	center: 'center',
	right: 'right',
	izq: 'left',
	cen: 'center',
	der: 'right',
	izquierda: 'left',
	centro: 'center',
	centrado: 'center',
	derecha: 'right',
}


const validSize = {
	xxs: "xx-small",
	xs: "x-small",
	sm: "small",
	md: "medium",
	lg: "large",
	xl: "x-large",
	xxl: "xx-large",
	"xx-small": "xx-small",
	"x-small": "x-small",
	small: "small",
	medium: "medium",
	large: "large",
	"x-large": "x-large",
	"xx-large": "xx-large"
}

const alignclasses = {
	left: { p: "text-left", div: "justify-content-start" },
	center: { p: "text-center", div: "justify-content-center" },
	right: { p: "text-right", div: "justify-content-end" },
	none: { p: "", div: "justify-content-around" },
}

const PComponet = ({ children, node: { children: nodechildren = [] } }) => {
	const hasElements = nodechildren.some(node => node.type !== 'text' && !validPChildren.includes(node.tagName))

	const findTextTag = (nodes, tagname) => nodes.find(node => node.tagName === tagname && node.children[0]?.type === "text")?.children[0].value
	//validAlign[(nodechildren[0]?.tagName == 'align' && nodechildren[0].children[0]?.type == "text" && nodechildren[0].children[0].value ) || "none"];

	const align = validAlign[findTextTag(nodechildren, "align") || "none"]
	const size = validSize[findTextTag(nodechildren, 'size') || "md"]
	let customClasses = findTextTag(nodechildren, 'clases') || findTextTag(nodechildren, 'classes');

	const hasCustomClasses = typeof customClasses === "string"
	customClasses = customClasses?.split(';') || []

	let alignClass = hasCustomClasses
		? { div: [customClasses.at(-2), customClasses.at(-1)], p: customClasses.at(0) }
		: (alignclasses[align] || alignclasses.none);

	alignClass = {
		div: [
			firstValid(customClasses[0], "mb-2 mt-1 container-fluid"),
			firstValid(customClasses[1], `row ${alignClass.div}`)
		],
		p: firstValid(customClasses[0], `mb-2 ${alignClass.p}`)
	}

	return hasElements
		? <div className={alignClass.div[0]} ><div className={alignClass.div[1]} >{children}</div></div>
		: <p className={alignClass.p} style={{ fontSize: size }} >{children}</p>
}


export default PComponet